namespace Ir.Components.Filters.ComparisonFilter.ComparisonFilterList {
    interface IViewModel {
        comparisonFilters: KnockoutObservable<ComparisonFilter[]>;
        isToolbar: KnockoutObservable<boolean>;
        isDrilldownTab: boolean;
    }

    interface IParams {
        comparisonFilters: KnockoutObservableArray<ComparisonFilter>;
        config: IComparisonFilterListParams;
    }

    export interface IComparisonFilterListParams {        
        isToolbar?: KnockoutObservable<boolean>;
        isDrilldownTab: boolean;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.comparisonFilters = ko.computed(() => { return params.comparisonFilters().filter(x => x.dateOption() !== ComparisonDateOptionEnum.Manual); });
        this.isToolbar = params.config.isToolbar;
        this.isDrilldownTab = params.config.isDrilldownTab;
    }
}